import ChatHeader from './ChatHeader';
import ChatInput from './ChatInput';
import ChatStream from './ChatStream';

type ChatHeaderCompoundProps = {
  title?: string;
  onClose?: () => void;
};

const ChatHeaderCompound = ({
  title = 'Klue Assistant',
  onClose,
}: ChatHeaderCompoundProps) => {
  return <ChatHeader title={title} onClose={onClose} />;
};

export const Chat = {
  Header: ChatHeaderCompound,
  Stream: ChatStream,
  Input: ChatInput,
};

export default Chat;
